import { render, staticRenderFns } from "./ProvinceIndexCategoryView.vue?vue&type=template&id=9ec53564&"
import script from "./ProvinceIndexCategoryView.vue?vue&type=script&lang=js&"
export * from "./ProvinceIndexCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports